module.exports = __webpack_public_path__ + "img/gallery.e75320e8.png";